import React, { Fragment } from 'react';
import OurBlogs from '../../components/OurBlogs';
import Footer from '../../components/footer';
import PageTitle from '../../components/pagetitle';
import Scrollbar from '../../components/scrollbar';
import WithOutBlogSilder from '../../components/WithOutBlogSilder';
import News from '../../components/News';

const NewsPage = () =>
{
    return (
        <Fragment>
            <PageTitle pageTitle={ 'News' } pagesub={ 'News' } />
            <News />
            <Footer />
            <Scrollbar />
        </Fragment>
    );
};
export default NewsPage;
